export default __webpack_public_path__ + "static/media/RossBassett.772f0356.jpg";